import React from 'react';

const AetherBackground = () => {
  return (
    <div
      id="three-canvas"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        pointerEvents: 'none',
        display: 'block',
        backgroundImage: 'url("https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=100&w=3000&auto=format&fit=crop")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        filter: 'brightness(1.0) contrast(1.1)',
      }}
    >
      {/* Lighter overlay gradient to keep the image clear but allow text to pop */}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.4) 100%)'
      }} />
    </div>
  );
};

export default AetherBackground;
